<template>
  <b-card class="deal-card mb-1" :class="{ 'active-deal': active_card }"  @click="$emit('select-deal', deal)">
    <span class="deal-id">#{{ deal_id }}</span>
    <h6 class="deal-title text-overflow">{{ deal.title }}</h6>

    <div class="deal-footer"> 
      <div class="deal-price">${{ numberFormat(decimalFixed(deal.price), true) }}</div>

      <b-badge
        :variant="getStatusVariant(deal.order_statuses.status)"
        pill
        class="text-capitalize"
      >
        <span v-if="deal.order_statuses.status === 'approved_links' && !deal.order_statuses.is_completed">{{ $t('creator.type_status.review_links') }}</span>
        <span v-else>{{ $t(`creator.type_status.${deal.order_statuses.status}`) }}</span>
      </b-badge>
    </div>
  </b-card>
</template>
  
<script>
import { BCard, BBadge } from "bootstrap-vue";
import { decimalFixed, numberFormat, getIdFromDate } from "@/libs/utils/formats";

export default {
  name: "DealPaidCard",
  components: {
    BCard,
    BBadge,
  },
  props: {
    deal: {
      type: Object,
      required: true,
    },
    active_card: {
      type: Boolean,
      default: false
    },
  },
  computed : {
    deal_id() {
      return getIdFromDate(this.deal?.order_statuses?.created_at ?? new Date());
    },
  },
  methods: {
    decimalFixed,
    numberFormat,
    getStatusVariant(status) {
      const variants = {
        creating: "warning",
        content_submitted: "info",
        content_accepted: "success",
        waiting_links: "warning",
        approved_links: "success",
      };
      return variants[status] || "light";
    },
  },
};
</script>
  
<style scoped lang="scss">
.deal-card {
  .card-body {
    padding: 1.8em 1em;
  }
  border-radius: 12px;
  border: 1px solid #e0e0e0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.2s ease;
  cursor: pointer;
  background-color: #fff;
  border-left: 7px solid transparent;

}

.deal-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
}

.deal-title {
  font-size: 14px;
  font-weight: 600;
  margin: 0;
  color: #2d2d2d;
}

.deal-id {
  position: absolute;
  top: 8px;
  right: 12px;
  font-size: 10px;
  color: #bbb;
  font-weight: 400; 
}

.deal-price {
  font-size: 15px;
  font-weight: 700;
  color: #0096fe;
}
.text-overflow {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.deal-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 6px;
}
.active-deal {
  border: 1.5px solid #0096fe;
  border-left: 7px solid #0096fe;
  background: white;
  border-radius: 10px;
}
</style>